import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d572298c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-fluid p-0" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-sm-auto sticky-top pe-0 shadow-sm" }
const _hoisted_4 = {
  class: "d-flex flex-sm-column flex-row flex-nowrap bg-lightgreen h-100 sticky-top",
  id: "sideBar"
}
const _hoisted_5 = { class: "nav nav-pills nav-flush w-100 flex-row flex-sm-column flex-nowrap text-center justify-content-around align-items-center" }
const _hoisted_6 = { class: "col-sm p-5 min-vh-100" }
const _hoisted_7 = { class: "text-start fw-bold pb-3" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border border-dark border-2 opacity-100" }, null, -1))
const _hoisted_9 = {
  key: 0,
  id: "transactionsSection"
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = {
  key: 1,
  class: "m-5"
}
const _hoisted_12 = { class: "text-center text-black-50" }
const _hoisted_13 = {
  key: 1,
  class: "m-5"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "text-center text-black-50" }, "No transactions available.", -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TransactionItem = _resolveComponent("TransactionItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            (_ctx.role === 'Charity')
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  class: _normalizeClass(["nav-item h-100 flex-fill", _ctx.activeTab === 'Awaiting' ? 'bg-secondary' : 'bg-none'])
                }, [
                  _createElementVNode("button", {
                    type: "button",
                    class: "nav-link w-100 py-3 px-4 rounded-0",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchTab('Awaiting'))),
                    ref: "awaitingTab"
                  }, [
                    _createElementVNode("em", {
                      class: _normalizeClass(["bi bi-hourglass fs-2", _ctx.activeTab === 'Awaiting' ? 'text-white' : 'text-dark'])
                    }, null, 2)
                  ], 512)
                ], 2))
              : _createCommentVNode("", true),
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item h-100 flex-fill", _ctx.activeTab === 'Completed' ? 'bg-secondary' : 'bg-none'])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "nav-link w-100 py-3 px-4 rounded-0",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchTab('Completed'))),
                ref: "completedTab"
              }, [
                _createElementVNode("em", {
                  class: _normalizeClass(["bi bi-clipboard-check fs-2", 
                    _ctx.activeTab === 'Completed' ? 'text-white' : 'text-dark'
                  ])
                }, null, 2)
              ], 512)
            ], 2),
            _createElementVNode("li", {
              class: _normalizeClass(["nav-item h-100 flex-fill", _ctx.activeTab === 'Cancelled' ? 'bg-secondary' : 'bg-none'])
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "nav-link w-100 py-3 px-4 rounded-0",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchTab('Cancelled'))),
                ref: "cancelledTab"
              }, [
                _createElementVNode("em", {
                  class: _normalizeClass(["bi bi-slash-circle fs-2", 
                    _ctx.activeTab === 'Cancelled' ? 'text-white' : 'text-dark'
                  ])
                }, null, 2)
              ], 512)
            ], 2)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h1", _hoisted_7, _toDisplayString(_ctx.activeTab) + " Transactions", 1),
        _hoisted_8,
        (_ctx.transactions.length > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_ctx.filteredTransactions.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredTransactions, (transaction, index) => {
                      return (_openBlock(), _createBlock(_component_TransactionItem, {
                        key: transaction.transactionId,
                        index: index,
                        class: "mb-3",
                        role: _ctx.role,
                        windowWidth: _ctx.windowWidth,
                        transaction: transaction
                      }, null, 8, ["index", "role", "windowWidth", "transaction"]))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("h3", _hoisted_12, " No " + _toDisplayString(_ctx.activeTab.toLowerCase()) + " transactions. ", 1)
                  ]))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      ])
    ])
  ]))
}